module Tapas.Bindings {
    export class QuickOrder {
        public init(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

            var resultRowClassName = valueAccessor();
            var number = -1;
            var resultCount = -1;
            var targetElement = $(element);
            var resultRows = $(resultRowClassName);    
            var productName;
			
            //Prevent default behaviour 
            targetElement.on("keydown", function (e) {
                if (e.which == 38 || e.which == 40 || e.which == 9)
                    e.preventDefault();
            });    
            
            //The function for going up and down        
            function upAndDown() {
                var resultRows = $(resultRowClassName);
                resultCount = resultRows.length - 1;
                $('#instantBuySearch').focus();
                //Make sure user cant go over or under
                if (number > resultCount) {
                    number = -1;
                } else if (number < -1) {
                    number = resultCount;
                }
                resultRows.removeClass('active');
                $(resultRowClassName + '.' + number).addClass('active');
            }

            //The function where we select the product
            //This is used both with mouse and keyboard
            function selectProduct() {
				var productId;
                var productName;
                var variantId;

				if ($(".QuickAddproductCount").length == 1) {
                    productId = $(resultRowClassName).attr("ftw-productid");
                    variantId = $(resultRowClassName).attr("ftw-variantId");
					productName = $(resultRowClassName).text().replace(/\s+/g, " ");
				}
				else {
                    productId = $(resultRowClassName + '.' + number).attr("ftw-productid");
                    variantId = $(resultRowClassName + '.' + number).attr("ftw-variantId");
					productName = $(resultRowClassName + '.active').text().replace(/\s+/g, " ");
                }                
                $("#quickOrderForm").attr("ftw-productid", productId);
                $("#quickOrderForm").attr("ftw-variantId", variantId);

                $('.productName').val(productName);
                $('#quickOrderQuantity').focus().select();

                $("#quickOrderQuantity").bind('input', function () {
                    var quantity = $('#quickOrderQuantity').val();
                    $("#quickOrderForm").attr("ftw-quantity", quantity);
                });
            }

            //The function for resetting everything
            //This is used both with mouse and keyboard 
            function reset() {
                $('.productName').val("");
                $("#quickOrderForm").attr("ftw-productid", "");
                $("#quickOrderForm").attr("ftw-variantId", "");
                $("#quickOrderForm").attr("ftw-quantity", "1");
                $("#quickOrderQuantity").val("1");
                $('#instantBuySearch').val("").focus();
                $('.result').hide();
                number = -1;
            }

            //On hover we want to set number to the correct product
            //And we want to add class 'active'
            $('.result').on('mouseenter', '.customTable .tableRow', function () {
                $('.customTable .tableRow').removeClass('active');
                $(this).addClass('active');
                number = parseInt($(this).attr('ftw-count'));
            });
            $('.result').on('mouseleave', '.customTable .tableRow', function () {
                $(this).removeClass('active');
            });

            $('.result').on('click', '.customTable .tableRow', function () {
                selectProduct();
            });

            $('.quickAdd').on('click', function (e) {
                if ($(e.target).hasClass('quickAdd') && productName !== '') {
                    $('#quickOrderForm').submit();
                    reset();
                }
            });


            //Here we run the function for going up and down
            //The select, put to cart and reset functionality
            targetElement.on("keyup", function (e) {
                var code = e.which;
				var quantityFocus = $("#quickOrderQuantity").is(":focus");
				var count = $(".QuickAddproductCount").length;

                if (code == 40) { // Up key
                    number++;
                    upAndDown();
                }
				else if (code == 38) { //Down key
                    number--;
                    upAndDown();
                }
				else if ((code == 9 || code == 13) && (number < 0 && count != 1)) {
                    e.preventDefault();
				}
				else if ((code == 9 || code == 13) && (number >= 0 || count == 1)) {
                    resultCount = resultRows.length;
                    if (quantityFocus == false) {
                        selectProduct();
                    } else if (code !== 9) {
                        $('#quickOrderForm').submit();
                        reset();
                    }
                }
                else if(quantityFocus == false) {
                    number = -1;
                }
            });
        }
    }
    ko.bindingHandlers['quickOrder'] = new QuickOrder();
}